var parent = require('../../actual/symbol/iterator');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/full/symbol/iterator.js
// module id = 463
// module chunks = 0 1